export interface MangaChapter {
  id: string;
  title: string;
  number: number;
  date: string;
}

export interface Manga {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  status: '连载中' | '已完结';
  category: '日漫' | '韩漫' | '国漫';
  tags: string[];
  rating: number;
  views: number;
  updatedAt: string;
  chapters: MangaChapter[];
  featured: boolean;
  isNew: boolean;
}

export const mangas: Manga[] = [
  {
    id: 'manga-1',
    title: '咒术回战',
    author: '芥见下下',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20cover%20art%20with%20dynamic%20action%20pose%20of%20a%20young%20sorcerer%20with%20dark%20hair%20fighting%20against%20supernatural%20cursed%20spirits%20in%20urban%20Tokyo%20setting%2C%20bold%20line%20art%20with%20vibrant%20red%20and%20black%20color%20scheme%2C%20Japanese%20shonen%20manga%20aesthetic&width=600&height=850&seq=manga-cover-01&orientation=portrait',
    description: '少年与诅咒之间的战斗，从未停止。虎杖悠仁吞下宿傩手指后，踏入了咒术师的世界。在东京都立咒术高等专门学校，他与伙伴们一起对抗诅咒，面对前所未有的强大敌人。热血与友情交织的王道战斗漫画，带给你最震撼的阅读体验。',
    status: '连载中',
    category: '日漫',
    tags: ['热血', '战斗', '奇幻', '校园'],
    rating: 9.5,
    views: 1280000,
    updatedAt: '2026-08-03',
    chapters: [
      { id: 'ch-1-1', title: '第271话 最终决战', number: 271, date: '2026-08-03' },
      { id: 'ch-1-2', title: '第270话 领域展开', number: 270, date: '2026-07-27' },
      { id: 'ch-1-3', title: '第269话 五条的觉悟', number: 269, date: '2026-07-20' },
      { id: 'ch-1-4', title: '第268话 逆袭', number: 268, date: '2026-07-13' },
      { id: 'ch-1-5', title: '第267话 宿傩的真身', number: 267, date: '2026-07-06' },
    ],
    featured: true,
    isNew: false,
  },
  {
    id: 'manga-2',
    title: '我独自升级',
    author: 'Chugong / DUBU',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20cover%20art%20featuring%20a%20powerful%20black-haired%20hunter%20with%20glowing%20purple%20eyes%20and%20shadow%20army%20behind%20him%2C%20dramatic%20lighting%20with%20dark%20purple%20and%20black%20tones%2C%20manhwa%20aesthetic%20with%20sharp%20art%20style&width=600&height=850&seq=manga-cover-02&orientation=portrait',
    description: '被称为"人类最弱兵器"的成振宇，在一次双重 dungeon 事故后觉醒了"系统"能力。从此，他成为了唯一能够"升级"的猎人。从 E 级到 S 级，从被嘲讽到傲视群雄，见证最弱者的逆袭之路！',
    status: '已完结',
    category: '韩漫',
    tags: ['系统', '升级', '战斗', '逆袭'],
    rating: 9.7,
    views: 2560000,
    updatedAt: '2026-06-15',
    chapters: [
      { id: 'ch-2-1', title: '第179话 终章', number: 179, date: '2026-06-15' },
      { id: 'ch-2-2', title: '第178话 最后的战斗', number: 178, date: '2026-06-08' },
      { id: 'ch-2-3', title: '第177话 君主的陨落', number: 177, date: '2026-06-01' },
    ],
    featured: true,
    isNew: false,
  },
  {
    id: 'manga-3',
    title: '一人之下',
    author: '米二',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20cover%20art%20with%20a%20young%20man%20using%20traditional%20Taoist%20martial%20arts%20techniques%20surrounded%20by%20flowing%20energy%20and%20ancient%20Chinese%20symbols%2C%20ink%20wash%20painting%20style%20blended%20with%20modern%20comic%20art&width=600&height=850&seq=manga-cover-03&orientation=portrait',
    description: '平凡大学生张楚岚因爷爷的失踪，被卷入异人世界的纷争。在这个隐藏于现代社会之下的异能者世界中，他将揭开身世之谜，修炼炁体源流，与各路高手一决高下。国漫扛鼎之作！',
    status: '连载中',
    category: '国漫',
    tags: ['异能', '修真', '热血', '悬疑'],
    rating: 9.4,
    views: 1890000,
    updatedAt: '2026-08-02',
    chapters: [
      { id: 'ch-3-1', title: '第598话 真相浮现', number: 598, date: '2026-08-02' },
      { id: 'ch-3-2', title: '第597话 八奇技之谜', number: 597, date: '2026-07-26' },
      { id: 'ch-3-3', title: '第596话 天师下山', number: 596, date: '2026-07-19' },
    ],
    featured: true,
    isNew: false,
  },
  {
    id: 'manga-4',
    title: '间谍过家家',
    author: '远藤达哉',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20cover%20art%20featuring%20a%20stylish%20family%20of%20three%20including%20a%20man%20in%20suit%20a%20woman%20with%20red%20hair%20and%20a%20cute%20pink-haired%20little%20girl%20with%20telepathic%20abilities%2C%20warm%20and%20humorous%20tone%2C%20clean%20art%20style&width=600&height=850&seq=manga-cover-04&orientation=portrait',
    description: '为了执行秘密任务，顶级间谍"黄昏"组建了一个虚假家庭。但他不知道的是，妻子是杀手，女儿是超能力者！三人互相隐瞒身份，却渐渐产生了真正的亲情。温馨搞笑与紧张刺激完美融合！',
    status: '连载中',
    category: '日漫',
    tags: ['搞笑', '温馨', '间谍', '家庭'],
    rating: 9.3,
    views: 1560000,
    updatedAt: '2026-08-01',
    chapters: [
      { id: 'ch-4-1', title: '第108话 家庭旅行', number: 108, date: '2026-08-01' },
      { id: 'ch-4-2', title: '第107话 安妮亚的考试', number: 107, date: '2026-07-25' },
    ],
    featured: false,
    isNew: true,
  },
  {
    id: 'manga-5',
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20cover%20showing%20a%20young%20man%20reading%20a%20glowing%20book%20in%20a%20post-apocalyptic%20world%20with%20monsters%20and%20constellations%20in%20the%20sky%2C%20dramatic%20fantasy%20lighting%2C%20detailed%20manhwa%20art&width=600&height=850&seq=manga-cover-05&orientation=portrait',
    description: '金独子是唯一读到一部末世小说结局的人。当小说中的世界变为现实，他成为了唯一知道剧情走向的"读者"。利用先知先觉的优势，他将在末日中生存下去，改写所有人的命运。',
    status: '连载中',
    category: '韩漫',
    tags: ['末世', '系统', '生存', '智斗'],
    rating: 9.6,
    views: 2130000,
    updatedAt: '2026-08-03',
    chapters: [
      { id: 'ch-5-1', title: '第234话 星座之战', number: 234, date: '2026-08-03' },
      { id: 'ch-5-2', title: '第233话 鬼怪的新娘', number: 233, date: '2026-07-27' },
    ],
    featured: true,
    isNew: false,
  },
  {
    id: 'manga-6',
    title: '镖人',
    author: '许先哲',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20depicting%20a%20fierce%20warrior%20with%20sword%20riding%20a%20horse%20across%20the%20desert%20in%20ancient%20China%20Tang%20Dynasty%20setting%2C%20ink%20brush%20style%20with%20powerful%20strokes%20and%20dramatic%20composition&width=600&height=850&seq=manga-cover-06&orientation=portrait',
    description: '大业三年，隋朝。江湖浪客刀马带着孩子小七行走西域，接下了一趟改变命运的镖。硬派武侠画风，史诗级叙事，被誉为"国漫之光"。刀光剑影中的侠义与人性！',
    status: '连载中',
    category: '国漫',
    tags: ['武侠', '历史', '硬派', '江湖'],
    rating: 9.5,
    views: 1420000,
    updatedAt: '2026-07-30',
    chapters: [
      { id: 'ch-6-1', title: '第118话 大漠孤烟', number: 118, date: '2026-07-30' },
      { id: 'ch-6-2', title: '第117话 知世郎', number: 117, date: '2026-07-23' },
    ],
    featured: false,
    isNew: false,
  },
  {
    id: 'manga-7',
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20cover%20with%20a%20young%20swordsman%20wearing%20a%20green%20and%20black%20checkered%20haori%20holding%20a%20nichirin%20blade%20with%20water%20breathing%20effects%2C%20demon%20slayer%20aesthetic%20with%20traditional%20Japanese%20pattern%20background&width=600&height=850&seq=manga-cover-07&orientation=portrait',
    description: '大正时代，少年灶门炭治郎一家惨遭鬼的杀害，唯一幸存的妹妹祢豆子却变成了鬼。为了让妹妹恢复人类，炭治郎踏上了斩杀恶鬼的旅途。感动了全世界的现象级作品！',
    status: '已完结',
    category: '日漫',
    tags: ['热血', '战斗', '兄妹', '鬼怪'],
    rating: 9.2,
    views: 3200000,
    updatedAt: '2026-05-20',
    chapters: [
      { id: 'ch-7-1', title: '第205话 生命的延续', number: 205, date: '2026-05-20' },
    ],
    featured: false,
    isNew: false,
  },
  {
    id: 'manga-8',
    title: '剑尊归来',
    author: 'LICO / Redice Studio',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20featuring%20a%20handsome%20martial%20artist%20with%20long%20silver%20hair%20holding%20a%20sword%20with%20cherry%20blossoms%20falling%20around%20him%2C%20elegant%20and%20powerful%20fantasy%20martial%20arts%20aesthetic&width=600&height=850&seq=manga-cover-08&orientation=portrait',
    description: '天下第一剑尊在飞升之际意外回到了少年时代。凭借前世的记忆和剑术，他重新踏上武道之路，誓要弥补前世所有的遗憾。超爽的复仇升级路线，画面精美到每一格都可以当壁纸！',
    status: '连载中',
    category: '韩漫',
    tags: ['重生', '武侠', '爽文', '画风精美'],
    rating: 9.4,
    views: 1780000,
    updatedAt: '2026-08-02',
    chapters: [
      { id: 'ch-8-1', title: '第156话 剑神降临', number: 156, date: '2026-08-02' },
      { id: 'ch-8-2', title: '第155话 天外有天', number: 155, date: '2026-07-26' },
    ],
    featured: false,
    isNew: true,
  },
  {
    id: 'manga-9',
    title: '镇魂街',
    author: '许辰',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20showing%20a%20young%20man%20with%20fiery%20aura%20summoning%20ancient%20Chinese%20guardian%20spirits%20in%20a%20modern%20urban%20fantasy%20setting%2C%20dynamic%20action%20pose%20with%20intense%20flame%20effects&width=600&height=850&seq=manga-cover-09&orientation=portrait',
    description: '普通大学生夏铃收到一份神秘快递后，被卷入了镇魂街的世界。在这里，她将觉醒守护灵的力量，与伙伴们一起守护人界与灵域的平衡。热血国漫的标杆之作！',
    status: '连载中',
    category: '国漫',
    tags: ['热血', '奇幻', '守护灵', '冒险'],
    rating: 9.3,
    views: 1650000,
    updatedAt: '2026-08-01',
    chapters: [
      { id: 'ch-9-1', title: '第386话 最终防线', number: 386, date: '2026-08-01' },
      { id: 'ch-9-2', title: '第385话 群英汇聚', number: 385, date: '2026-07-25' },
    ],
    featured: false,
    isNew: false,
  },
  {
    id: 'manga-10',
    title: '电锯人',
    author: '藤本树',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20cover%20art%20with%20a%20blonde%20young%20man%20with%20chainsaw%20arms%20and%20head%20in%20a%20chaotic%20urban%20battle%20scene%2C%20wild%20and%20gritty%20art%20style%20with%20splashes%20of%20bright%20orange%20and%20red&width=600&height=850&seq=manga-cover-10&orientation=portrait',
    description: '背负着父亲巨额债务的少年淀治，在濒死之际与电锯恶魔波奇塔融合，成为了"电锯人"。加入公安对魔特异4课后，他的人生发生了翻天覆地的变化。藤本树的疯狂与天才之作！',
    status: '连载中',
    category: '日漫',
    tags: ['黑暗', '战斗', '恶魔', '邪道'],
    rating: 9.1,
    views: 1980000,
    updatedAt: '2026-07-31',
    chapters: [
      { id: 'ch-10-1', title: '第185话 预言', number: 185, date: '2026-07-31' },
      { id: 'ch-10-2', title: '第184话 那由多', number: 184, date: '2026-07-24' },
    ],
    featured: false,
    isNew: false,
  },
  {
    id: 'manga-11',
    title: '某天成为公主',
    author: 'Plutus / Spoon',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20fantasy%20cover%20with%20a%20beautiful%20princess%20in%20an%20elegant%20rose-gold%20dress%20in%20a%20palace%20garden%2C%20soft%20pastel%20colors%20with%20sparkling%20magical%20atmosphere%2C%20shojo%20manhwa%20style&width=600&height=850&seq=manga-cover-11&orientation=portrait',
    description: '一觉醒来变成了小说中的悲催公主？而且按照剧情她将在18岁被亲生父亲处死！为了活下去，雅典娜开始拼命攻略冷血父皇。从被嫌弃到被宠爱，这段父女情看哭了无数读者。',
    status: '已完结',
    category: '韩漫',
    tags: ['穿越', '亲情', '治愈', '宫廷'],
    rating: 9.5,
    views: 2340000,
    updatedAt: '2026-04-10',
    chapters: [
      { id: 'ch-11-1', title: '第125话 幸福结局', number: 125, date: '2026-04-10' },
    ],
    featured: false,
    isNew: false,
  },
  {
    id: 'manga-12',
    title: '狐妖小红娘',
    author: '小新',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20showing%20a%20beautiful%20fox%20spirit%20girl%20with%20long%20flowing%20hair%20in%20traditional%20Chinese%20red%20dress%20surrounded%20by%20peach%20blossoms%20and%20magical%20energy&width=600&height=850&seq=manga-cover-12&orientation=portrait',
    description: '以红娘为职业的狐妖涂山苏苏，为前世的爱人们牵线搭桥，帮助他们再续前缘。一段跨越千年的爱情故事，在人与妖共存的世界中徐徐展开。唯美画风，感人至深！',
    status: '连载中',
    category: '国漫',
    tags: ['爱情', '奇幻', '转世', '治愈'],
    rating: 9.2,
    views: 1450000,
    updatedAt: '2026-07-29',
    chapters: [
      { id: 'ch-12-1', title: '第512话 千年之约', number: 512, date: '2026-07-29' },
      { id: 'ch-12-2', title: '第511话 前世记忆', number: 511, date: '2026-07-22' },
    ],
    featured: false,
    isNew: false,
  },
];

export const categories = [
  { slug: 'riman', name: '日漫', icon: 'ri-sun-line', count: 4, description: '来自日本的漫画作品，包含热血少年漫、少女漫、青年漫等多种类型' },
  { slug: 'hanman', name: '韩漫', icon: 'ri-moon-line', count: 4, description: '韩国网络漫画，以精美画风和独特叙事著称，多为全彩条漫' },
  { slug: 'guoman', name: '国漫', icon: 'ri-star-line', count: 4, description: '国产漫画精品，融合中国传统文化与现代审美，日益崛起' },
];

export const faqs = [
  {
    question: '番茄漫画是免费阅读的吗？',
    answer: '是的！番茄漫画上的所有漫画作品均提供免费在线阅读，无需付费。我们致力于为广大漫迷提供最优质的免费漫画阅读体验，让每一位读者都能无障碍地享受漫画的乐趣。',
  },
  {
    question: '如何获取最新话更新提醒？',
    answer: '您可以通过关注番茄漫画的社交媒体账号或在网站上收藏您喜欢的漫画作品来获取最新话更新提醒。我们会第一时间推送更新通知，让您不错过任何精彩内容。',
  },
  {
    question: '支持哪些设备阅读？',
    answer: '番茄漫画支持全平台阅读，包括电脑端、平板和手机端。我们的下拉式滚动阅读模式针对各种屏幕尺寸进行了优化，无论使用什么设备都能获得流畅舒适的阅读体验。',
  },
  {
    question: '漫画的更新频率是怎样的？',
    answer: '不同漫画的更新频率不同，大多数热门连载漫画保持周更节奏，部分作品为双周更或月更。您可以在每部漫画的详情页查看具体的更新计划和历史更新记录。',
  },
  {
    question: '番茄漫画有APP吗？',
    answer: '我们正在积极开发番茄漫画移动端APP，敬请期待！目前您可以通过手机浏览器访问我们的网站，同样能获得流畅的下拉式滚动阅读体验。建议将网站添加到手机桌面，使用起来就像原生APP一样方便。',
  },
];